import styled from 'styled-components';
import { COLORS } from 'styles';
import { Col, Navbar } from 'react-bootstrap';
import bgCarne from 'assets/bg_carne.jpg';

export const Header = styled.header``;

export const BG = styled.div`
  background-image: url('/bg.png');
  background-size: cover;
`;

export const ButtonCardapio = styled.a`
  display: block;
  background: #9987c9;
  color: white !important;
  font-size: calc(1rem + 0.3vw);
  font-family: 'Oswald', sans-serif;
  font-weight: bold;
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 20px;
  border: 0;
  text-decoration: none;
  outline: none;
  span {
    position: absolute;
    padding: 20px;
    bottom: 0;
    right: 0;
    display: inline-block;
    background: #8c7fb0;
  }
  :hover {
    opacity: 0.8;
    text-decoration: none;
    outline: none;
  }
  :active {
    background: #56477d;
    span {
      background: #726596;
    }
  }
`;

export const NavLink = styled(Navbar.Brand)`
  font-family: 'Oswald', sans-serif;
  justify-content: center;
  align-items: center;

  small {
    letter-spacing: 0.5px;
    font-weight: bold;
  }
`;

export const ColLeft = styled(Col)`
  p {
    font-family: 'Oswald', cursive;
    font-size: calc(1.5rem + 0.2vw);
    color: ${COLORS.texto};
    font-weight: 300;
    opacity: 0.9;
  }
`;

export const ColRight = styled(Col)`
  /* background-image: linear-gradient(100deg, #fcdec2 50%, #582200 10%); */
  @media (max-width: 991.98px) {
    img {
      height: 400px;
    }
  }
  @media (max-width: 767.98px) {
    img {
      height: 350px;
    }
  }
  @media (max-width: 512.98px) {
    img {
      height: 300px;
    }
  }
`;

export const LegendImg = styled.p`
  color: ${COLORS.accent};
  position: relative;
  font-style: italic;
  font-size: calc(1.5rem + 1.3vw);
  font-family: 'Pacifico', cursive;
  letter-spacing: 0.5px;
`;

export const BackgroundHeader = styled.div`
  background-image: linear-gradient(110deg, #fff 67%, #582200 30%);
  @media (max-width: 1199.98px) {
    background-image: linear-gradient(125deg, #fff 80vw, #582200 50vw);
  }
  @media (max-width: 767.98px) {
    background-image: linear-gradient(135deg, #fff 50%, #582200 50%);
  }
  @media (max-width: 991.98px) {
    background-image: linear-gradient(150deg, #fff 50%, #582200 50%);
  }
`;

export const TextoHorario = styled.p`
  font-family: 'Oswald', cursive;
  font-size: 1.1rem;
  color: white;
  opacity: 0.9;
  margin: 0;
`;

export const TextoCard = styled.p`
  padding-top: 10px;
  text-decoration-line: underline;
  text-decoration-color: ${COLORS.primary};

  padding-bottom: 10px;
  font-family: 'Oswald', cursive;
  font-size: 1.5rem;
  color: #636e72;
  letter-spacing: 2px;
  margin: 0;
`;

export const TitileInsta = styled.p`
  color: white;
  position: relative;
  font-style: italic;
  font-size: calc(1rem + 0.9vw);
  font-family: 'Pacifico', cursive;
  letter-spacing: 0.5px;
`;

export const TitleGoogle = styled.p`
  color: ${COLORS.accent};
  position: relative;
  font-style: italic;
  font-size: calc(1.9rem);
  font-family: 'Pacifico', cursive;
  letter-spacing: 0.5px;
`;

export const SubtitleGoogle = styled.p`
  color: ${COLORS.texto};
  position: relative;
  font-size: calc(2rem + 0.5vw);
  font-family: 'Anton', cursive;
  letter-spacing: 2px;
`;

export const SubtitleInsta = styled.p`
  color: ${COLORS.accent};
  position: relative;
  font-size: calc(2rem + 0.2vw);
  font-family: 'Anton', cursive;
  letter-spacing: 2px;
`;

export const H1 = styled.h1`
  color: ${COLORS.texto};
  font-family: 'Oswald', cursive;
`;

export const H4 = styled.h4`
  color: ${COLORS.texto};
  font-family: 'Oswald', cursive;
`;

export const H6 = styled.h6`
  color: ${COLORS.texto};
  font-family: 'Oswald', cursive;
`;
export const TitleLink = styled.p`
  color: #f8b779;
  font-size: calc(1rem + 0.5vw);
  font-family: 'Anton', cursive;
  letter-spacing: 2px;
`;

export const BGInsta = styled.div`
  background-image: url(${bgCarne});
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.6);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  padding: 80px 0;
  margin-bottom: 40px;
`;

export const ButtonSocial = styled.a`
  width: 85%;
  display: flex;
  align-items: center;
  background: ${props => props.color};
  color: white !important;
  font-size: calimport { Background } from '../Cardapio/styles';
c(1rem + 0.3vw);
  font-family: 'Oswald', sans-serif;
  font-weight: bold;
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 20px;
  border: 0;
  text-decoration: none;
  outline: none;
  p.social-nome {
    display: inline-block;
    margin: 0;
    padding-left: 20px;
  }
  span {
    position: absolute;
    padding: 20px;
    bottom: 0;
    right: 30px;
    display: inline-block;
    background: ${props => props.color};
    box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.2);
    z-index: 2;
  }
  :hover {
    opacity: 0.8;
    text-decoration: none;
    outline: none;
  }
  :active {
    background: #56477d;
    span {
      background: #726596;
    }
  }
`;
